import { createAsyncThunk } from '@reduxjs/toolkit';

import { incrementApTestPrepTimeSpent } from '../../../../AP/services/slices/APSliceActions/IncrementApTestPrepTimeSpentAction';
import { RootState } from '../../../../App/store';
import { isAPCourse, isSATCourse } from '../../../../Common/services/utils';
import { mapCourseDataById } from '../../../../Learn/services/mappers';
import { incrementSATTestPrepTimeSpent } from '../../../../SAT/services/slices';
import { TEST_PREP_SLICE_NAME } from '../TestPrepSlice';

export const countTestPrepTimeSpent = createAsyncThunk(
  `${TEST_PREP_SLICE_NAME}/countTestPrepTimeSpent`,
  (courseId: string, thunkAPI) => {
    const rootState = thunkAPI.getState() as RootState;
    const courseData = mapCourseDataById(rootState, courseId);

    if (!courseData?.id) {
      return;
    }

    if (isAPCourse(courseData)) {
      thunkAPI.dispatch(incrementApTestPrepTimeSpent(courseData.id));
      return;
    }

    if (isSATCourse(courseData)) {
      thunkAPI.dispatch(incrementSATTestPrepTimeSpent());
      return;
    }
  },
);
